import { IAutomationAppComponent } from "../../types";
import { schema } from "./types";
import { OverviewPanel,OperatorPanel } from '.';
import { ParameterPanel } from "./ParameterPanel";
import { IoFolderOpenOutline } from "react-icons/io5";


export const App : IAutomationAppComponent = {
    schema: schema,
    supportsProcessPanel: false,
    Icon: IoFolderOpenOutline,
    OverviewPanel: OverviewPanel,
    OperatorPanel: OperatorPanel,
    ParameterPanel: ParameterPanel,
    createConfig: {
        group: "Utilities",
        name: "A folder to structure the application",
        description: "Folder",
        panel: OverviewPanel,
        defaultState: { },
    },
}